SA.formatValue = function(value, format) {
    if (value == null) {
        return '';
    }

    switch (format) {
        case '%s':
            return value + '';
        case '%d':
            return separateDigits(Math.round(value) + '');
        case '%01.2f%%':
            return separateDigits(twoDecimalPlaces(value)) + '%';
        case '$%01.2f':
            return '$' + separateDigits(twoDecimalPlaces(value));
    }

    return separateDigits(sprintf(format, value));

    function separateDigits(value) {
        var index = value.indexOf('.'),
            charBefore;

        if (index === -1) {
            index = value.length;
        }

        index -= 3;

        while (index > 0) {
            charBefore = value.charAt(index - 1);

            if (charBefore < '0' || charBefore > '9') {
                break;
            }

            value = value.slice(0, index) + ',' + value.slice(index);

            index -= 3;
        }

        return value;
    }

    function twoDecimalPlaces(value) {
        var sign = '',
            integer, decimal;

        if (-0.005 < value && value < 0.005) {
            return '0.00';
        }

        if (value < 0) {
            sign = '-';
            value = -value;
        }

        integer = Math.floor(value);
        decimal = Math.round((value - integer) * 100);

        if (decimal === 100) {
            ++integer;
            decimal = 0;
        }

        if (decimal < 10) {
            decimal = '0' + decimal;
        }

        return (sign + integer + '.' + decimal);
    }
};

